<template>
  <v-container width="100%" style="background: #f5f5f5">
    <v-dialog v-model="editDialog" max-width="900px">
      <ManageStandardEquipment
        title="Editar equipamento padrão"
        :standardEquipment="currentStandardEquipment"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <div id="header" class="mt-5 px-3">
      <h2>{{ $t('Dados do equipamento') }}</h2>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ma-1"
            color="#0F3565"
            dark
            @click="editStandardEquipment(currentStandardEquipment)"
            v-bind="attrs"
            v-on="on"
            small
          >
            <v-icon dark small> mdi-pencil-outline </v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
    </div>
    <v-divider class="my-3"></v-divider>

    <v-row class="px-5">
      <v-col>
        <div>
          <p>
            <strong class="field">{{ $t('Equipamento') }}:</strong>
            {{ currentStandardEquipment.name }}
          </p>
          <p>
            <strong class="field">{{ $t('Função') }}:</strong>
            {{
              isNumber(currentStandardEquipment.functionEquipment)
                ? $t(
                    functionsEquipment[
                      currentStandardEquipment.functionEquipment
                    ]
                  )
                : $t(currentStandardEquipment.functionEquipment)
            }}
          </p>
          <p>
            <strong class="field">Índice ABC:</strong>
            {{ currentStandardEquipment.indexAbc }}
          </p>
          <p>
            <strong class="field">Exp.Vida:</strong>
            {{ currentStandardEquipment.lifeExpectancy }}
          </p>
        </div>
      </v-col>
      <v-col>
        <div>
          <p>
            <strong class="field">{{ $t('Sigla') }}:</strong>
            {{ currentStandardEquipment.initials }}
          </p>
          <p>
            <strong class="field">{{ $t('Risco') }}:</strong>
            {{
              isNumber(currentStandardEquipment.equipmentRisk)
                ? $t(equipmentRisks[currentStandardEquipment.equipmentRisk])
                : $t(currentStandardEquipment.equipmentRisk)
            }}
          </p>
          <p>
            <strong class="field">{{ $t('Oficina') }}:</strong>
            {{
              isNumber(currentStandardEquipment.workshopType)
                ? $t(workshopTypes[currentStandardEquipment.workshopType])
                : $t(currentStandardEquipment.workshopType)
            }}
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
#header {
  display: flex;
  justify-content: space-between;
}
.field {
  display: block;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import ManageStandardEquipment from './ManageStandardEquipment.vue'

export default {
  props: {
    receivedStandardEquipment: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.currentStandardEquipment = this.receivedStandardEquipment
    if (!this.isNumber(this.receivedStandardEquipment.functionEquipment)) {
      this.receivedStandardEquipment.functionEquipment =
        this.functionsEquipment.indexOf(
          this.receivedStandardEquipment.functionEquipment
        )
    }

    if (!this.isNumber(this.receivedStandardEquipment.equipmentRisk)) {
      this.receivedStandardEquipment.equipmentRisk =
        this.equipmentRisks.indexOf(
          this.receivedStandardEquipment.equipmentRisk
        )
    }

    if (!this.isNumber(this.receivedStandardEquipment.workshopType)) {
      this.receivedStandardEquipment.workshopType = this.workshopTypes.indexOf(
        this.receivedStandardEquipment.workshopType
      )
    }

    this.currentStandardEquipment.functionEquipment =
      this.functionsEquipment[this.receivedStandardEquipment.functionEquipment]
    this.currentStandardEquipment.equipmentRisk =
      this.equipmentRisks[this.receivedStandardEquipment.equipmentRisk]
    this.currentStandardEquipment.workshopType =
      this.workshopTypes[this.receivedStandardEquipment.workshopType]
  },

  data: () => ({
    currentStandardEquipment: {},
    dialogKey: false,
    editDialog: false,
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    workshopTypes: ['Engenharia clínica', 'Manutenção predial'],
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit('close')
    },

    isNumber(value) {
      return typeof value === 'number'
    },

    closeDialog() {
      this.editDialog = false
      this.dialogKey = !this.dialogKey
    },

    editStandardEquipment(standardEquipment) {
      this.currentStandardEquipment = standardEquipment
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },
  },

  components: {
    ManageStandardEquipment,
  },
}
</script>

<style></style>
